import { Variant } from "@material-ui/core/styles/createTypography";
import React from "react";
import { Title } from "../templates";
import { WidgetProps } from "./models";

export interface TitleOptions {
  margin?: "normal" | "none";
  variant?: Variant;
  prefix?: string;
  suffix?: string;
  allowHtml?: boolean;
}

interface TitleWidgetProps extends WidgetProps<string> {
  options: TitleOptions;
}

export const TitleWidgetComponent = (props: TitleWidgetProps) => {
  const { id, schema, value, options } = props;
  const { margin = "none", variant, prefix, suffix, allowHtml } = options;

  let title = value || schema.title;

  if (!title) {
    throw Error(`title must be specified for ${id}.`);
  }

  if (prefix) {
    title = prefix + title;
  }

  if (suffix) {
    title = title + suffix;
  }

  return <Title fieldId={id} margin={margin} variant={variant} title={title} allowHtml={allowHtml} />;
};

export const TitleWidget = TitleWidgetComponent;
